{
  "NAME": "CallRecIntegration",
  "AddCallRecIntegrationTitle": "Integration der Anrufaufzeichnung hinzufügen",
  "ModifyCallRecIntegrationTitle": "Integration der Anrufaufzeichnung ändern",
  "TabGeneralTitle": "Allgemein",
  "TabScopeAssignmentsTitle": "Umfang Zuweisungen",
  "TabApiCommunicationsTitle": "Api Kommunikation",
  "TabDubberCommunicationsTitle": "Dubber Kommunikation",
  "IdentifierGUID": "Bezeichner (GUID):",
  "IdentifierGUIDPlaceholder": "[Automatisch zugewiesen]",
  "IntegrationType": "Art der Integration:",
  "IntegrationType_1": "[Unbekannter oder nicht spezifizierter Typ]",
  "IntegrationType_2": "Dubber Corporation Limited",
  "ModifyCallRecIntegrationDescriptionFormLabel": "Beschreibung:",
  "DubberApiComSettingsLocationUrls": "Dubber Location URL:",
  "ApiComSettingsIPAddrOne": "IP-Adresse 1 (MAIN):",
  "ApiComSettingsIPAddrTwo": "IP-Adresse 2 (SECONDARY):",
  "ApiComSettingsAuthDetailsMainTitle": "Angaben zur Authentifizierung (MAIN)",
  "ApiComSettingsAuthDetailsMainUserName": "Benutzername (MAIN):",
  "ApiComSettingsAuthDetailsMainUserPassword": "Passwort (MAIN):",
  "ApiComSettingsAuthDetailsSecondaryTitle": "Angaben zur Authentifizierung (SECONDARY):",
  "ApiComSettingsAuthDetailsSecondaryUserName": "Benutzername (sekundär):",
  "ApiComSettingsAuthDetailsSecondaryUserPassword": "Passwort (sekundär):",
  "ApiComSettingsApiParamOne": "API-Parameter 1:",
  "ApiComSettingsApiParamTwo": "API-Parameter 2:",
  "DubberComSettingsApiParamOne": "Kontoname (TRAILING PART):",
  "DubberComSettingsApiParamTWO": "Konto Benutzer \/ E-MAIL (OPTIONAL):",
  "DubberComSettingsTitle": "Dubber Kommunikationseinstellungen",
  "DubberComSettingsLocationURL": "Dubber Location URL:",
  "DubberComSettingsDevAuthTitle": "Entwickler-Authentifizierung",
  "DubberComSettingsDevAuthUserName": "Benutzername (MASHERYID KEY):",
  "DubberComSettingsDevAuthUserPassword": "Passwort (MASHERYID SECRET):",
  "DubberComSettingsAccountApiAuthTitle": "Konto-API-Authentifizierung",
  "DubberComSettingsAccountApiAuthUserName": "Benutzername (API AUTH ID):",
  "DubberComSettingsAccountApiAuthUserPassword": "Passwort (API AUTH TOKEN):",
  "DubberComSettingAccountName": "Kontoname (nachgestellter Teil)",
  "DubberComSettingsAccountUserEmail": "Konto Benutzer \/ E-Mail (OPTIONAL)",
  "CallRecIntegrationAddModify_UnknownOrDeleted": "[Unbekannt oder Gelöscht]",
  "CallRecIntegrationAddModify_ServerErrorTitle": "Validierungsfehler",
  "CallRecIntegrationAddModify_ValidationWarning": "Bitte stellen Sie sicher, dass alle Felder korrekt ausgefüllt sind",
  "CallRecIntegrationAddModify_ButtonHelpLabel": "Hilfe?",
  "CallRecIntegrationAddModify_ButtonSubmitLabel": "Speichern Sie",
  "CallRecIntegrationAddModify_ButtonCancelLabel": "Abbrechen",
  "CallRecIntegrationAddModify_PromptMessage": "Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "CallRecIntegrationAddModify_PromptConfirm": "Ja",
  "CallRecIntegrationAddModify_PromptCancel": "Abbrechen",
  "Error_TestIntegration_Timeout": "Test-Integrationsanmeldung mit Zeitüberschreitung",
  "InputField_Change_Username": "[Benutzername ändern]",
  "InputField_Change_Password": "[Passwort ändern]",
  "DubberComSettings_Parameters": "Parameter",
  "DubberComSettings_TestIntegrationAuth": "Testintegrationsauthentifizierung"
}